import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
document.addEventListener('DOMContentLoaded', function() {
    const customPostosSections = document.querySelectorAll('.js-section-custom-posts-block');
    customPostosSections.forEach((section) => {
        var swiperEl = section.querySelector('.js-custom-posts-swiper');
        if (swiperEl) {
            var mySwiper = new Swiper(swiperEl, {
                // Konfiguracja karuzeli
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 24,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                // np. autoHeight: true,
                // grabCursor: true,
            });
        }
    });
});
